import { LegendSwatch } from "@/shared/components/legend-swatch";
import styles from "./conflito-gantt-secao.module.scss";
import type { ConflitoGanttSecaoProps } from "./types-conflito-gantt-secao";

export function ConflitoGanttSecaoView({ titulo, legenda, children }: ConflitoGanttSecaoProps) {
  return (
    <section className={styles.secao} aria-label={titulo}>
      <span className={styles.titulo}>{titulo}</span>
      <ul className={styles.legenda} aria-label="Legenda" data-testid="resolver-conflito-legenda">
        <li className={styles.legendaTitulo}>Legenda:</li>
        {legenda.map((item) => (
          <li key={item.key} className={styles.legendaItem}>
            <LegendSwatch kind={item.key} />
            {item.label}
          </li>
        ))}
      </ul>
      <div className={styles.gantt} data-testid="resolver-conflito-gantt">
        {children}
      </div>
    </section>
  );
}
